import { useLingui } from "@lingui/react/macro";
import type { LabelSizeKey } from "@/types/label-template";

/**
 * Stock names, translated.
 *
 * The API sends an English name with each size for Swagger; the UI translates
 * from the key so a kitchen reads its own language. The inches stay as the API
 * sent them — a 3-inch sticker is 3 inches everywhere.
 */
export function useLabelSizeNames(): Record<LabelSizeKey, string> {
  const { t } = useLingui();
  return {
    "1x3": t`1" x 3" prep label`,
    "4x6": t`4" x 6" case label`,
  };
}
